import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HelpModalState {
  isOpen: boolean;
}

const initialState: HelpModalState = {
  isOpen: false,
};

const helpModalSlice = createSlice({
  name: "helpModal",
  initialState,
  reducers: {
    openHelpModal: (state) => {
      state.isOpen = true;
    },
    closeHelpModal: (state) => {
      state.isOpen = false;
    },
    setHelpModal: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const { openHelpModal, closeHelpModal, setHelpModal } = helpModalSlice.actions;
export default helpModalSlice.reducer;
